import { atom } from "jotai";

// Bridges the Design page's "save the currently active component" logic
// (LoadProject's triggerLoadMethod, which knows which component ref -
// battery/controller/pv/etc. - is active and calls its submit handler) to
// other parts of the app that don't have direct access to those refs, such
// as SideMenu's version-switch-blocked modal "Save" action.
//
// Usage:
//   Producer (LoadProject):
//     const [, setSaveTrigger] = useAtom(saveTriggerAtom);
//     useEffect(() => {
//       setSaveTrigger(() => triggerLoadMethod);
//       return () => setSaveTrigger(null);
//     }, [triggerLoadMethod, setSaveTrigger]);
//
//   Consumer (SideMenu):
//     const [saveTrigger] = useAtom(saveTriggerAtom);
//     await saveTrigger?.();
export const saveTriggerAtom = atom(null);
